import { Meta } from '../../../graphql/graphql';

export default function findMetaValue(meta: Meta[], key: string) {
	if (!meta) {
		return null;
	}

	return meta.find(item => item.key === key);
}
